module.exports = __webpack_public_path__ + "img/11.d8d45fef.jpg";